export const $stripe = () => {
  const stripe = Stripe(__STRIPE_PUBLIC_KEY)
  return stripe;
}